// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  card: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E5E5',
    borderRadius: theme.spacing(1),
    boxShadow: '4px 6px 8px 0px #00000017',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  cardHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  orderCredit: {
    color: '#F95264',
  },
  subscriptionCredit: {
    color: theme.palette.primary.main,
  },
});

export default styles;
